import { IS_REGISTRATION_BANNER_OPEN } from "../constants";
export const toggleIsRegistrationBannerOpen = value => ({
  type: IS_REGISTRATION_BANNER_OPEN,
  value
});